var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoundSigninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.468 19.086h8.352v-1.98h-3.222c-.414 0-.846.018-1.314.018.468-.558.612-1.152.612-1.8 0-.666-.198-1.35-.414-1.908h2.25v-1.962h-2.934a4.171 4.171 0 0 1-.306-1.566c0-1.062.504-1.908 1.656-1.908 1.044 0 1.584.72 1.746 1.638h2.196C16.09 7.332 14.578 6 12.238 6 9.61 6 8.134 7.71 8.134 9.834c0 .558.09 1.152.216 1.674H7v1.908h2.178c.288.63.432 1.206.432 1.746 0 1.08-.63 1.908-2.142 2.088v1.836Z",
  fill: "#252829"
})));
export default SvgPoundSigninline;